module.exports = function() {
  return new Worker(__webpack_public_path__ + "6a8d581a09fdde6425a7.worker.js");
};